// extracted by css-extract-rspack-plugin
export default {"cls1":"CitingSourcesCard-cls1_067","cls2":"CitingSourcesCard-cls2_Bri CitingSourcesCard-cls1_067"};